import React, { useEffect, useState } from "react";
import { loadStyles } from "../../../utils/cssLoader";
import NextImage from "../NextImage"
import TestMatchTabs from "../../cricket/TestMatchTabs";
import { getImageUrl, teamLeagueInfoUrl } from "../../../utils/generalLiveCenter";

const IceHockeyStandingTable = ({ ServerData,
  loadCSS = true,
  dataClient = false,
  title,
  sport = "icehockey",
  websiteBaseUrl,
  dataPath,

}) => {
  const [clientData, setClientData] = useState(null);
  const data = dataClient ? clientData : ServerData;

  useEffect(() => {
    if (!dataClient) return;
    const container = document?.querySelector(".microservice-cont");
    const raw = container?.getAttribute("data-listingdata");
    if (!raw) return;

    try {
      const parsed = JSON.parse(raw)?.data?.data;
      setClientData(parsed || null);
    } catch (err) {
      console.error("Failed to parse data-listingdata:", err);
    }
  }, [dataClient]);

  useEffect(() => {
    if (loadCSS === "true") {
      loadStyles("leaguestandings");
    }
  }, [loadCSS]);

  const items = Object?.keys(data || {})?.map((key) => ({
    label: key,
    value: key,
  })) || [];

  const [activeItem, setActiveItem] = useState(items[0]?.label || null);

  const getFilteredData = (activeItem) => {
    if (!data || !activeItem) return [];
    return data[activeItem] || [];
  };

  useEffect(() => {
    if (items.length > 0 && !activeItem) {
      setActiveItem(items[0].value);
    }
  }, [items, activeItem]);

  return (
    <>
      <TestMatchTabs
        items={items}
        activeItem={activeItem}
        onClick={setActiveItem}
      />
      <div className={`global_table   ice_team_table`}>
        <table>
          <thead>
            <tr>
              <th>#</th>
              <th>Teams</th>
              <th>P</th>
              <th>W</th>
              <th>D</th>
              <th>L</th>
              <th>W(AET)</th>
              <th>L(AET)</th>
              <th>W(AP)</th>
              <th>L(AP)</th>
              <th>F</th>
              <th>AG</th>
              <th>DIFF</th>
              <th>PTS</th>
            </tr>
          </thead>
          <tbody>
            {getFilteredData(activeItem)?.map((row, i) => (
              <tr key={i}>
                <td>
                  <span
                    className="hi-border"
                    style={{ backgroundColor: `${row?.clr}` }}
                  ></span>
                  <span className="d-inline-block align-middle">
                    {row?.plc}
                  </span>
                </td>
                <td>
                  <a
                    href={teamLeagueInfoUrl({
                      dataClient,
                      websiteBaseUrl,
                      dataPath,
                      category: "team",
                      sport,
                      name: row?.tnam,
                      id: row?.tid,
                    })}
                  >
                    <div className="des-wrap">
                      <span className="flg_img">
                        <NextImage
                          src={getImageUrl('', '', sport, row?.tid)}
                          height={23}
                          width={23}
                          alt="teamLogo"
                          priority={false}
                        />
                      </span>
                      <span className="des-text">{row?.tnam}</span>
                    </div>
                  </a>
                </td>
                <td>{row?.ply}</td>
                <td>{row?.wins}</td>
                <td>{row?.dra}</td>
                <td>{row?.los}</td>
                <td>{row?.w_aet}</td>
                <td>{row?.los_aet}</td>
                <td>{row?.wi_ap}</td>
                <td>{row?.los_ap}</td>

                <td>{row?.gol_f}</td>
                <td>{row?.gol_ag}</td>
                <td>{row?.gol_dif}</td>
                <td>{row?.pts}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </>
  );
};

export default IceHockeyStandingTable;
